// Add Custom Pagination
function initLeftDotsPagination(scope = document) {
  const wrapper = scope.querySelector(".featured-img-wrapper");
  if (!wrapper || wrapper.dataset.dotsInit === "true") return;

  const gallery = wrapper.querySelector(".product-feature-image");
  if (!gallery) return;

  const slides = Array.from(gallery.querySelectorAll(":scope > .gp-image-item"));
  if (slides.length < 2) return;

  wrapper.dataset.dotsInit = "true";

  const dots = [];

  slides.forEach((slide, currentIndex) => {
    const pagination = document.createElement("div");
    pagination.className = "custom-slide-pagination";

    slides.forEach((_, dotIndex) => {
      const dot = document.createElement("button");
      dot.type = "button";
      dot.className = "gp-dot";
      if (dotIndex === currentIndex) dot.classList.add("active");

      dot.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        slides[dotIndex].scrollIntoView({ behavior: "smooth", block: "start" });
      });

      pagination.appendChild(dot);
      if (currentIndex === 0) dots.push(dot);
    });

    slide.appendChild(pagination);
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const activeIndex = slides.indexOf(entry.target);
      if (activeIndex === -1) return;

      gallery.querySelectorAll(".custom-slide-pagination").forEach(pag => {
        pag.querySelectorAll(".gp-dot").forEach((dot, i) => {
          dot.classList.toggle("active", i === activeIndex);
        });
      });
    });
  }, { threshold: 0.5, rootMargin: "-10% 0px -10% 0px" });

  slides.forEach(slide => observer.observe(slide));
}

document.addEventListener("DOMContentLoaded", () => {
  initLeftDotsPagination();

  // ✅ Target DOM 
  const gpTarget = document.querySelector(".featured-img-wrapper")
                || document.querySelector(".product-feature-image");

  if (gpTarget) {
    let gpTimer = null;
    const gpObserver = new MutationObserver(() => {
      clearTimeout(gpTimer);
      gpTimer = setTimeout(initLeftDotsPagination, 150);
    });

    // ✅ Specific element mila — subtree:false safe hai
    gpObserver.observe(gpTarget, {
      childList: true,
      subtree: false,
      attributes: false
    });
  }
});